import http from '@/communication/AuthConnection'

/**
* Read the file dropped
*/
const readFile = (pFile, eventId, { documentTypeId, description, documentFieldsForm }) => {
  const formData = new FormData()
  formData.append('file', pFile)
  formData.append('eventId', eventId)

  formData.append('documentTypeId', documentTypeId)
  formData.append('description', description)
  formData.append('documentFieldsForm', JSON.stringify(documentFieldsForm))

  return http
    .post('/v1/documents/repository', formData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    })
}

export default readFile



// WEBPACK FOOTER //
// ./src/view/event-documents/components/document-upload/FileHandle.js